import { selectScenarioName } from 'state/detourSlices';
import { useAppSelector } from 'state/hooks';
import { getProjectInfoForSlug, selectUser } from 'state/userSlice';
import {
  selectCurrentScenarioId,
  selectProject,
  selectTargetDate,
} from 'state/workflowSlice';

import { useRouteProperties } from 'features/common/hooks/useRouteProperties';

import MapTooltip from '../tooltips/MapTooltip';

interface IScreenshotExtras {
  info?: Record<string, string>;
}
export default function ScreenshotExtras({ info = {} }: IScreenshotExtras) {
  const routeProperties = useRouteProperties();
  const scenarioName = useAppSelector(selectScenarioName);
  const project = useAppSelector(selectProject);
  const user = useAppSelector(selectUser);
  const currentScenarioId = useAppSelector(selectCurrentScenarioId);
  const targetDate = useAppSelector(selectTargetDate);

  const data = {
    ...info,
  };
  // Show the date for targetDate-based modules whenever time is displayed
  if (data.time && !data.duration) data.date = targetDate;
  if (routeProperties?.freeflowSpeed !== undefined)
    data.freeflow_speed = routeProperties.freeflowSpeed;

  if (routeProperties?.cardinalDirection !== undefined)
    data.direction = routeProperties.cardinalDirection;

  if (routeProperties?.routeLength !== undefined)
    data.route_length = routeProperties.routeLength;

  if (routeProperties?.freeflowTraveltime !== undefined)
    data.freeflow_travel_time = routeProperties.freeflowTraveltime;

  const hasData = Object.values(data).some((value) => value !== undefined);

  if (!hasData) return null;

  const title =
    (currentScenarioId && scenarioName) ||
    routeProperties?.name ||
    getProjectInfoForSlug(user, project)?.project_name ||
    project;
  return <MapTooltip data-show-in-export title={title} data={data} />;
}
